import React from "react";
import { Modal } from "react-bootstrap";
import { pure } from "recompose";

import PaymentsWidget from "./index";

const PaymentsPopup = pure(props => (
  <Modal show={true} backdrop="static" dialogClassName="mg-payments-popup">
    <Modal.Body>
      <PaymentsWidget mode="popup" {...props} />
    </Modal.Body>
  </Modal>
));

export default PaymentsPopup;



// WEBPACK FOOTER //
// ./src/components/payments/popup.js